import CustomTooltip from "../../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { toast } from "../../../../components/ui/use-toast";

const ProgramSummaryActionButton = ({
  item,
}) => {
  const handleDownload = async (export_report_path) => {
    try {
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "file.pdf");
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      toast({
        variant: "destructive",
        description: errors,
        duration: 3000,
      });
    }
  };

  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"Download"}>
          <span>
            <FontAwesomeIcon
              onClick={() => handleDownload(item?.file)}
              icon={faDownload}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
      </span>
    </>
  );
};

export default ProgramSummaryActionButton;
